import { useMemo } from 'react';
import useTagsStore from '../tags/useStore';
import useActivitiesStore from './activities/useStore';
import useProcessesStore from './processes/useStore';
import usePropertiesStore from './properties/useStore';
import useRolesStore from './roles/useStore';
import useSkillsStore from './skills/useStore';

const LIBRARY = {
  activities: null,
  processes: null,
  properties: null,
  tags: null,
  roles: null,
  skills: null,
  isLoading: true,
  updatedAt: Date.now(),
};

/**
 * @param {Function} get
 * @returns {*}
 */
export default function useLibrary(get = (state) => state) {
  const activities = useActivitiesStore();
  const processes = useProcessesStore();
  const properties = usePropertiesStore();
  const tags = useTagsStore();
  const roles = useRolesStore();
  const skills = useSkillsStore();

  const library = useMemo(() => {
    LIBRARY.activities = activities;
    LIBRARY.processes = processes;
    LIBRARY.properties = properties;
    LIBRARY.roles = roles;
    LIBRARY.skills = skills;
    LIBRARY.tags = tags;

    LIBRARY.updatedAt = new Date();
    LIBRARY.isLoading =
      activities.isLoading ||
      processes.isLoading ||
      properties.isLoading ||
      skills.isLoading ||
      tags.isLoading;

    return LIBRARY;
  }, [activities, processes, properties, roles, skills, tags]);

  return useMemo(() => get(library), [library?.updatedAt]);
}
